import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/* Layout */
import Layout from "../views/layout/Layout";

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true,
  },
  { path: "/404", component: () => import("@/views/404"), hidden: true },
];

export const asyncRouterMap = [
  {
    path: "",
    component: Layout,
    redirect: "/home",
    hidden: true,
    children: [
      {
        path: "/home",
        name: "home",
        component: () => import("@/views/home/index"),
        meta: { title: "后台主页", icon: "home" },
        hidden: true,
      },
    ],
  },
  {
    path: "/ums",
    component: Layout,
    redirect: "/ums/admin",
    name: "ums",
    hidden: true,
    meta: { title: "系统管理", icon: "ums" },
    children: [
      {
        path: "/ums/admin",
        name: "admin",
        component: () => import("@/views/ums/admin/index"),
        meta: { title: "用户管理", icon: "ums-admin" },
        hidden: true,
      },
      {
        path: "/ums/role",
        name: "role",
        component: () => import("@/views/ums/role/index"),
        meta: { title: "角色管理", icon: "ums-role" },
        hidden: true,
      },
      {
        path: "/ums/allocMenu",
        name: "allocMenu",
        component: () => import("@/views/ums/role/allocMenu"),
        meta: { title: "分配菜单" },
        hidden: true,
      },
      {
        path: "/ums/allocResource",
        name: "allocResource",
        component: () => import("@/views/ums/role/allocResource"),
        meta: { title: "分配资源" },
        hidden: true,
      },
      {
        path: "/ums/menu",
        name: "menu",
        component: () => import("@/views/ums/menu/index"),
        meta: { title: "菜单列表", icon: "ums-menu" },
        hidden: true,
      },
      {
        path: "/ums/addMenu",
        name: "addMenu",
        component: () => import("@/views/ums/menu/add.vue"),
        meta: { title: "添加菜单" },
        hidden: true,
      },
      {
        path: "/ums/updateMenu",
        name: "updateMenu",
        component: () => import("@/views/ums/menu/update"),
        meta: { title: "修改菜单" },
        hidden: true,
      },
      {
        path: "/ums/resource",
        name: "resource",
        component: () => import("@/views/ums/resource/index"),
        meta: { title: "资源列表", icon: "ums-resource" },
        hidden: true,
      },
      {
        path: "/ums/resourceCategory",
        name: "resourceCategory",
        component: () => import("@/views/ums/resource/categoryList"),
        meta: { title: "资源分类" },
        hidden: true,
      },
    ],
  },
  {
    path: '/order',
    component: Layout,
    name: 'order',
    hidden: true,
    meta: { title: "订单管理", icon: "order" },
    children: [
      {
        path: '/order/list',
        name: 'orderList',
        component: () => import('@/views/order/order'),
        meta: {title: '订单列表', icon: 'order'},
        hidden: true,
      },
      {
        path: '/order/detail',
        name: 'orderDetail',
        component: () => import('@/views/order/orderDetail'),
        meta: {title: '订单详情', icon: 'order'},
        hidden: true,
      }
    ]
  },
  {
    path: '/goods',
    component: Layout,
    hidden: true,
    name: 'goods',
    meta: { title: "商品管理", icon: "goods" },
    children: [
      {
        path: '/goods/list',
        name: 'goodsList',
        component: () => import('@/views/goods/goods'),
        meta: {title: '商品列表', icon: 'goods'},
        hidden: true,
      },
      {
        path: '/goods/add',
        name: 'goodsAdd',
        component: () => import('@/views/goods/goodsAdd'),
        meta: {title: '商品添加', icon: 'goods'},
        hidden: true,
      },
      {
        path: '/goods/nature',
        name: 'nature',
        component: () => import('@/views/nature/nature'),
        meta: {title: '商品设置', icon: 'goods'},
        hidden: true,
      }
    ]
  },
  {
    path: '/cart',
    component: Layout,
    hidden: true,
    name: 'cart',
    meta: { title: "购物车", icon: "cart" },
    children: [
      {
        path: '/cart/list',
        name: 'cartList',
        component: () => import('@/views/cart/cart'),
        meta: {title: '购物车列表', icon: 'cart'},
        hidden: true,
      },
    ]
  },
  {
    path: '/settings',
    component: Layout,
    hidden: true,
    name: 'settings',
    meta: { title: "店铺设置", icon: "settings" },
    children: [
      {
        path: '/settings/showset',
        name: 'showset',
        component: () => import('@/views/showset/showset'),
        meta: {title: '显示设置', icon: 'showset'},
        hidden: true,
      },
      {
        path: '/ad/list',
        name: 'adList',
        component: () => import('@/views/ad/ad'),
        meta: {title: '广告列表', icon: 'ad'},
        hidden: true,
      },
      {
        path: '/ad/add',
        name: 'adAdd',
        component: () => import('@/views/ad/adAdd'),
        meta: {title: '添加广告', icon: 'ad'},
        hidden: true,
      },
      {
        path: '/settings/notice',
        name: 'notice',
        component: () => import('@/views/notice/notice'),
        meta: {title: '通知公告管理', icon: 'notice'},
        hidden: true,
      }
    ]
  },
  {
    path: '/category',
    component: Layout,
    hidden: true,
    name: 'category',
    meta: {title: '商品分类', icon: 'category'},
    children: [
      // {
      //   path: '/category',
      //   name: 'categoryList',
      //   component: () => import('@/views/category/category'),
      //   meta: {title: '商品分类列表', icon: 'category'},
      //   hidden: true,
      // },
      {
        path: '/category/add',
        name: 'categoryAdd',
        component: () => import('@/views/category/categoryAdd'),
        meta: {title: '添加商品分类', icon: 'category'},
        hidden: true,
      },
    ],
  },
  {
    path: '/specification',
    component: Layout,
    hidden: true,
    name: 'specification',
    meta: {title: '商品型号', icon: 'specification'},
    children: [
      {
        path: '/specification/add',
        name: 'specificationAdd',
        component: () => import('@/views/specification/specificationAdd'),
        meta: {title: '添加商品型号', icon: 'specification'},
        hidden: true,
      },
    ],
  },
  {
    path: '/user',
    component: Layout,
    hidden: true,
    name: 'user',
    meta: { title: "微信用户管理", icon: "user" },
    children: [
      {
        path: '/user/list',
        name: 'userList',
        component: () => import('@/views/user/user'),
        meta: {title: '微信用户列表', icon: 'user'},
        hidden: true,
      },
      {
        path: '/user/add',
        name: 'userAdd',
        component: () => import('@/views/user/userAdd'),
        meta: {title: '微信用户添加', icon: 'user'},
        hidden: true,
      },
    ]
  },
  {
    path: '/invoice',
    component: Layout,
    hidden: true,
    name: 'invoice',
    meta: { title: "开票管理", icon: "invoice" },
    children: [
      {
        path: '/invoice/list',
        name: 'invoiceList',
        component: () => import('@/views/invoice/invoice'),
        meta: {title: '开票列表', icon: 'invoice'},
        hidden: true,
      },
    ]
  },
  { path: "*", redirect: "/404", hidden: true },
];

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap,
});



// WEBPACK FOOTER //
// ./src/router/index.js